/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Faq_Who_AInputs */

const en_wc_faq_who_a = /** @type {(inputs: Wc_Faq_Who_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WordCraft is developed by the ArtCraft team. This site is an independent guide that hosts the browser editor and provides download help, tutorials and comparisons. The developers' product page is getartcraft.com/apps/wordcraft.`)
};

/**
* | output |
* | --- |
* | "WordCraft is developed by the ArtCraft team. This site is an independent guide that hosts the browser editor and provides download help, tutorials and compar..." |
*
* @param {Wc_Faq_Who_AInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_faq_who_a = /** @type {((inputs?: Wc_Faq_Who_AInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Faq_Who_AInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_faq_who_a(inputs)
});
export { wc_faq_who_a as "wc.faq.who.a" }